import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_Score } from './db-def.js';
export const ApiDef_Score = {
    _v1: {
        '?': { method: HttpMethod.POST, path: `v1/${DBDef_Score.dbKey}/post` },
        '??': { method: HttpMethod.GET, path: `v1/${DBDef_Score.dbKey}/get` },
    }
};
//# sourceMappingURL=api-def.js.map